module.exports = __webpack_public_path__ + "img/inspirational-motivator.b9f04b46.svg";